import { MOVE_STATUS_TRANSLATED, MOVE_TYPE_TRANSLATED } from '@/modules/move/entities/constants/move';
import { Move, MoveNormalized } from '@/modules/move/entities/interfaces/move';
import { MoveNormalizedProvider, MoveStatusTranslation } from '@/modules/move/entities/types/move';
import { getFormattedDate } from '@/utils/format';

export const normalizeStatus = ({ status }: Move): MoveStatusTranslation => {
  return MOVE_STATUS_TRANSLATED[status];
};

export const normalizeType = ({ type }: Move) => {
  return MOVE_TYPE_TRANSLATED[type];
};

export const normalizeProvider = ({ type }: Move): MoveNormalizedProvider => {
  return type?.includes('bradesco') ? 'Bradesco' : 'Outro';
};

export const normalizeList = (moves: Move[]): MoveNormalized[] => {
  if (!Array.isArray(moves)) {
    return [];
  }

  return moves.map(
    (move: Move): MoveNormalized => ({
      ...move,
      status: normalizeStatus(move),
      type: normalizeType(move),
      typeKey: move.type,
      provider: normalizeProvider(move),
      createdAt: getFormattedDate(move.createdAt || '', { showHours: true }),
      updatedAt: getFormattedDate(move.updatedAt || '', { showHours: true }),
      uploadedAt: getFormattedDate(move.uploadedAt || '', { showHours: true }),
    }),
  );
};
